class HeaderUtility {
  constructor() {
    this._channelId = this.setChannelId();
  }

  setChannelId(channel = 'web') {
    const isMobile = channel === 'mobile';
    this._channelId = isMobile ? '2' : '1';
  }

  getChannelId() {
    return this._channelId;
  }

  getHostname() {
    return window.THD_GLOBAL.nonSecureHostName || 'www.homedepot.com';
  }

  getCurrentUrl() {
    return window.location.href;
  }

  preventTouchHandling(event) {
    if (event.type === 'touchend') {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}

module.exports = new HeaderUtility();
